import React, { useEffect, useState } from 'react';

// What the backend does, in order. Advanced on a timer since the check is a
// single request; the last step stays active until the result arrives.
const STEPS = [
  'Formulamos la pregunta que haría un cliente tuyo',
  'Se la hacemos a una IA con búsqueda web en tiempo real',
  'Leemos qué negocios nombra en su respuesta'
];

const STEP_MS = 4000;

const CheckProgress = ({ input }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setActive((prev) => Math.min(prev + 1, STEPS.length - 1)),
      STEP_MS
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <div role="status" aria-live="polite">
      <p className="lp-kicker">Analizando · {input.businessName} · {input.city}</p>
      <h2 className="lp-display mt-5 text-[clamp(2.6rem,6.5vw,5.5rem)]">
        Preguntando a la IA<span className="text-[var(--lp-lime)]">…</span>
      </h2>

      <div className="mt-10 h-[3px] w-full max-w-2xl overflow-hidden rounded-full bg-[var(--lp-line)]">
        <div className="lp-scan h-full w-full" />
      </div>

      <ol className="mt-10 space-y-5">
        {STEPS.map((step, i) => (
          <li
            key={step}
            className={`flex items-baseline gap-5 text-lg transition-opacity duration-500 sm:text-xl ${
              i <= active ? 'opacity-100' : 'opacity-35'
            }`}
          >
            <span className={`lp-mono text-sm ${i === active ? 'text-[var(--lp-lime)]' : 'text-[var(--lp-muted)]'}`}>
              {String(i + 1).padStart(2, '0')}
            </span>
            {step}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default CheckProgress;
